/* Cart-only Sowth runtime: footer refresh + ship-bar bridge. */
(function () {
  function ping() { try { document.dispatchEvent(new CustomEvent('sowth:cartchanged')); } catch (e) {} }
  function pulseShipbar() {
    var inner = document.querySelector('.sowth-shipbar__inner');
    if (!inner) return;
    inner.classList.remove('is-sowth-updated');
    void inner.offsetWidth;
    inner.classList.add('is-sowth-updated');
    window.setTimeout(function () { inner.classList.remove('is-sowth-updated'); }, 700);
  }
  function updateFooter() {
    var cf = document.getElementById('main-cart-footer');
    if (!cf || !cf.dataset.id) { ping(); pulseShipbar(); return; }
    var id = cf.dataset.id;
    fetch(location.pathname + '?sections=' + id, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nc = doc.querySelector('.js-contents');
          var oc = cf.querySelector('.js-contents');
          if (nc && oc) oc.innerHTML = nc.innerHTML;
        }
        ping();
        pulseShipbar();
      })
      .catch(function () { ping(); pulseShipbar(); });
  }
  var pend;
  function schedule(delay) { clearTimeout(pend); pend = setTimeout(updateFooter, delay || 120); }
  function init() {
    var items = document.getElementById('main-cart-items');
    if (!items) return;
    if ('MutationObserver' in window) {
      new MutationObserver(function () { schedule(120); }).observe(items, { childList: true, subtree: true });
    }
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { schedule(120); });
    }
    document.addEventListener('click', function (e) {
      var el = e.target;
      if (el && el.closest && el.closest('cart-remove-button, .cart-remove-button, .quantity__button')) schedule(650);
    });
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.closest && el.closest('.quantity__input, cart-items, .cart-items, .cart__items')) schedule(650);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
